import {ReportType} from '../../../types/report-type'
import {LOJAS_COLUMN_LABELS} from '../lojasRelacionamento'

const COMMON: Record<string, string> = {
  IDPedido: 'Pedido',
  DataAprovado: 'Data Aprovado',
  DataFaturado: 'Data Faturado',
  DataEntregue: 'Data Entregue',
  DataCancelado: 'Data Cancelado',
  CNPJLojista: 'CNPJ',
  RazaoSocial: 'Razão Social',
  Industria: 'Indústria',
  IDSku: 'SKU',
  FamiliaProduto: 'Familia Produto',
  GrupoProduto: 'Grupo Produto',
  QuantidadeFaturada: 'Quantidade Faturada',
  PrecoTotalSemDesconto: 'Preço Total Sem Desconto',
  PrecoTotalComDesconto: 'Preço Total Com Desconto',
  ValorFaturado: 'Valor Faturado',
  ValorCorte: 'Valor Corte',
  OrigemPedido: 'Origem Pedido',
  TipoVenda: 'Tipo Venda',
  NomeVendedor: 'Nome Vendedor',
  Data: 'Data Captado',
  UnidadeNegocio: 'Unidade Negócio',
  DataCadastro: 'Data Cadastro',
  DataStatusClienteDistribuidor: 'Data Status Lojista Distribuidor',
  FLBlackListIndustria: 'FL BlackList Industria',
  PoliticaPreco: 'Política Preço',
  IDRede: 'ID Rede',
  IDGrupoEconomico: 'ID Grupo Econômico',
  TelefoneConfirmacaoToken: 'Telefone Confirmação Token',
  TelefoneLojista: 'Telefone Lojista',
  EmailConfirmacaoToken: 'E-mail Confirmação Token',
  StatusLojistaDistribuidor: 'Status',
  CargoVendedor: 'Cargo Vendedor',
  EmailVendedor: 'Email Vendedor',
  CelularVendedor: 'Celular Vendedor',
  DataUltimoAcesso: 'Último Acesso',
  EmailAprovador: 'Email Aprovador',
  DataOcorrenciaFaturado: 'Data Ocorrência Faturado',
  DataOcorrenciaEntrega: 'Data Ocorrência Entrega',
  DataOcorrenciaCancelado: 'Data Ocorrência Cancelado',
  NotaFiscal: 'Nota Fiscal',
  ValorTotal: 'Valor Total',
  DataOcorrenciaNotaFiscal: 'Data Ocorrência Nota Fiscal',
  DataNotaFiscal: 'Data Nota Fiscal',
  UnidadeDeNegocio: 'Unidade de Negócio',
  CepInicial: 'Cep Inicial',
  CepFinal: 'Cep Final',
  DistribuidorExclusivo: 'Distribuidor Exclusivo',
  Descricao: 'Descrição',
  AtendimentoEspecial: 'Atendimento Especial',
  TempoTransito: 'Tempo Trânsito',
  Nivel: 'Nível',
  IDLojista: 'ID Lojista',
  IDRegraPromocao: 'ID Regra Promoção',
  DescricaoCupom: 'Nome Cupom',
  NomeCompletoDistribuidor: 'Distribuidor',
  MesPedido: 'Mês Pedido',
  DataInicioVigenciaCupom: 'Data Início Cupom',
  DataFimVigenciaCupom: 'Data Término Cupom',
  FlgCupomUtilizado: 'Cupom Utilizado',
  ValorUtilizadoCupom: 'Valor Utilizado',
  TotalLojistaHabilitados: 'Lojistas Habilitados',
  TotalLojistaQueUtilizaram: 'Lojistas que Utilizaram',
  DataOcorrencia: 'Data Ocorrência',
  DataPreco: 'Data Preço',
  HoraPreco: 'Hora Preço',
  DataEstoque: 'Data Estoque',
  HoraEstoque: 'Hora Estoque',
  NomeProduto: 'Produto',
  NomeFamilia: 'Familia',
  NomeIndustria: 'Indústria',
  DescRegional: 'Desc Regional',
  CodigoPolitica: 'Código Politica',
  DescCodigo: 'Desc Codigo',
  DescNome: 'Desc Nome',
  ValorPreco: 'Valor Preço',
  QuantidadeEstoque: 'Quantidade Estoque',
  NomeCupom: 'Cupom',
  Distribuidor: 'Distribuidor',
  NomeDistribuidor: 'Distribuidor',
  NomesDistribuidoresPossiveis: 'Distribuidores Aptos',
  NomesDistribuidoresUtilizados: 'Distribuidor que Utilizou',
  MeioPagamento: 'Meio de Pagamento',
  PrazoPagamento: 'Prazo de Pagamento',
  DataApurado: 'Data Apurado',
  InvestimentoCaptado: 'Investimento Captado',
  PercentualDesconto: 'Percentual Desconto',
  PrecoUnitario: 'Preco Unitário',
  NomeRegra: 'Nome Promoção',
  MesAprovado: 'Mês Aprovado',
  MesFaturado: 'Mês Faturado',
  MesEntregue: 'Mês Entregue',
  MesCancelado: 'Mês Cancelado',
  IDMagentoLojista: 'ID Magento Lojista',
  IDMagentoIndustria: 'ID Magento Indústria',
  IDMagentoDistribuidor: 'ID Magento Distribuidor',
  IDMagentoProduto: 'ID Magento Produto',
  IDRegra: 'ID Regra',
  ValorPromocaoFaturada: 'Valor Promoção Faturada',
  DescontoUnitario: 'Desconto Unitário',
  DescontoTotal: 'Desconto Total',
  MesApurado: 'Mês Apurado',
  dt_ultima_compra: 'Data Última Compra',
  maior_compra_12m: 'Maior Compra 12m',
  dias_sem_compra: 'Dias sem Compra',
  motivo: 'Motivo',
  IDPoliticaPreco: 'ID Política Preço',
  NomeLojista: 'Lojista',
  CepInicio: 'CEP Início',
  CepFim: 'CEP Fim',
  FLBlackList: 'FL BlockList',
  PoliticaDePreco: 'Política de Preço',
  DataHoraPreco: 'Data Preço',
  NomeMarca: 'Marca',
  TipoPreco: 'Tipo de Preço',
  StatusIndustriaSite: 'Status Industria Site',
  StatusSellerSite: 'Status Seller Site',
  StatusEstoque: 'Status Estoque',
  IDZona: 'ID Zona',
  SKU: 'SKU',
  EAN: 'EAN',
  UF: 'UF',
}

const OVERRIDES: Partial<Record<ReportType, Record<string, string>>> = {
  lojistas: {
    Distribuidor: 'Distribuidor do Pedido',
    NomeDistribuidor: 'Distribuidor do Pedido',
  },
  vendedor_distribuidor: {
    DataStatusClienteDistribuidor: 'Data Status Cliente Distribuidor',
  },
  preco_estoque_hist: {
    NomeIndustria: 'Industria',
  },
  politica_preco: {
    NomeDistribuidor: 'Distribuidor',
    IDSku: 'ID SKU',
    TipoPreco: 'Preço',
  },
  ultimo_preco_estoque: {
    PoliticaPreco: 'Politica Preço',
    TipoPreco: 'Tipo Preço',
  },
}
OVERRIDES.nota_fiscal = OVERRIDES.notafiscal
OVERRIDES.lojas_quase_churn = LOJAS_COLUMN_LABELS
OVERRIDES.lojas_quase_fidelizadas = LOJAS_COLUMN_LABELS

export function reportColumnLabel(type: ReportType, column: string): string {
  return (
    OVERRIDES[type]?.[column] ||
    COMMON[column] ||
    column.replace(/_/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  )
}
